import ProtectedRoute from './ProtectedRoute.js'
export default ProtectedRoute;